import Swal from 'sweetalert2';

import { AuthState, signIn } from '../AuthState';
import { useAuthStep } from '../context/AuthStepContext';

const useSignInForm = () => {
  const {
    retries,
    hadTried,
    setIsLoading,
    email,
    nextStep,
    setHasAccount,
    setPin,
  } = useAuthStep();

  const pinUpdated = async (pin?: string) => {
    setPin(pin || '');
    const success = await attemptSignIn('', pin);
    if (success) {
      nextStep();
    } else {
      AuthState.pin = '';
      setPin('');
    }
  };

  const attemptSignIn = async (
    phoneNumber?: string,
    pin?: string,
  ): Promise<boolean> => {
    setIsLoading(true);
    let success = false;
    if (pin) {
      // means user is trying to sign in with pin
      hadTried();
    }
    await signIn(email, phoneNumber || null, pin || null)
      .then(async (res: any) => {
        if (res && res.challengeParam && res.challengeParam.email === email) {
          // Account exists but not finished
          setHasAccount(true);
        }
        success = true;
      })
      .catch((error: any) => {
        AuthState.pin = '';
        if (error.message.includes('Incorrect username or password')) {
          if (retries <= 0) {
            Swal.fire({
              icon: 'error',
              text: `You have run out of retries`,
              showConfirmButton: true,
            });
            // TODO: to handle run out of tries
          } else {
            Swal.fire({
              icon: 'error',
              text: `Incorrect code, you have ${retries - 1} retries left`,
              showConfirmButton: true,
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            text: 'There was a problem logging in. Please try again later',
            showConfirmButton: true,
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });

    return success;
  };

  return {
    attemptSignIn,
    pinUpdated,
  };
};

export { useSignInForm };
